// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"XV-z","inlineTitle":"YV-z","sponsoredAdsWrapper":"ZV-z","marketplaceRecosWrapper":"_V-z"};